export function buildListDocumentsQuery(filters = {}) {
  const parts = [];
  const {
    search,
    doc_type: docType,
    status,
    mimetype,
    channel,
    invoice_subtype: invoiceSubtype,
    supplier_cuit: supplierCuit,
    supplier_name: supplierName,
    issue_date_from: issueDateFrom,
    issue_date_to: issueDateTo,
    amount_min: amountMin,
    amount_max: amountMax,
    currency,
    confidence_band: confidenceBand,
    end_at_from: endAtFrom,
    end_at_to: endAtTo,
    limit = 100,
    orderBy = 'updated_at',
    orderDirection = 'desc',
  } = filters;

  if (search) parts.push(`search: "${search}"`);
  if (docType) parts.push(`doc_type: "${docType}"`);
  if (status) parts.push(`status: "${status}"`);
  if (mimetype) parts.push(`mimetype: "${mimetype}"`);
  if (channel) parts.push(`channel: "${channel}"`);
  if (invoiceSubtype) parts.push(`invoice_subtype: "${invoiceSubtype}"`);
  if (supplierCuit) parts.push(`supplier_cuit: "${supplierCuit}"`);
  if (supplierName) parts.push(`supplier_name: "${supplierName}"`);
  if (issueDateFrom) parts.push(`issue_date_from: "${issueDateFrom}"`);
  if (issueDateTo) parts.push(`issue_date_to: "${issueDateTo}"`);
  if (amountMin !== undefined && amountMin !== null && amountMin !== '') parts.push(`amount_min: ${Number(amountMin)}`);
  if (amountMax !== undefined && amountMax !== null && amountMax !== '') parts.push(`amount_max: ${Number(amountMax)}`);
  if (currency) parts.push(`currency: "${currency}"`);
  if (confidenceBand) parts.push(`confidence_band: "${confidenceBand}"`);
  if (endAtFrom) parts.push(`end_at_from: "${endAtFrom}"`);
  if (endAtTo) parts.push(`end_at_to: "${endAtTo}"`);
  parts.push(`orderBy: "${orderBy}"`);
  parts.push(`orderDirection: "${orderDirection}"`);
  parts.push(`limit: ${limit}`);

  const filterString = parts.length ? `(${parts.join(', ')})` : '';

  return `
    query ListDocuments {
      listDocuments${filterString} {
        totalCount
        items {
          document_id
          filename
          doc_type
          end_at
          updated_at
          status
          channel
          supplier_name
          supplier_cuit
          issue_date
          total_amount
          currency
          full_number
          cae
          confidence
          confidence_band
          invoice_subtype
          arca_validation {
            status
            severity
            result
            checked_at
            environment
            observations
            errors
            process_date
            audit_id
            retryable
            attempts
          }
          redirect_target_document_id
          redirect_target_doc_type
          bedrock_model_output {
            tipo_documento
            letra_documento
            fecha_emision
            punto_de_venta
            numero_documento
            razon_social_emisor
            cuit_emisor
            monto_total
            moneda
            codigo_factura
            CAE
            categoria_documento
            title
            summary
          }
        }
      }
    }
  `;
}

export function parseFileManagerSearchParams(searchParams) {
  const keys = [
    'search',
    'doc_type',
    'status',
    'mimetype',
    'channel',
    'invoice_subtype',
    'supplier_cuit',
    'supplier_name',
    'issue_date_from',
    'issue_date_to',
    'amount_min',
    'amount_max',
    'currency',
    'confidence_band',
    'end_at_from',
    'end_at_to',
  ];
  const filters = {};
  keys.forEach((key) => {
    const value = searchParams.get(key);
    if (value) filters[key] = value;
  });
  return filters;
}

export function buildFileManagerLink(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return query ? `/Filemanager?${query}` : '/Filemanager';
}
